/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharacterscurrency
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Currency" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersCurrency ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersCurrency extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Currency', [
            {
                character: '$',
                title: t('gg')
            },
            {
                character: '\u20AC',
                title: t('gh')
            },
            {
                character: '\xA5',
                title: t('gi')
            },
            {
                character: '\xA3',
                title: t('gj')
            },
            {
                character: '\xA2',
                title: t('gk')
            },
            {
                character: '\u20A0',
                title: t('gl')
            },
            {
                character: '\u20A1',
                title: t('gm')
            },
            {
                character: '\u20A2',
                title: t('gn')
            },
            {
                character: '\u20A3',
                title: t('go')
            },
            {
                character: '\u20A4',
                title: t('gp')
            },
            {
                character: '\xA4',
                title: t('gq')
            },
            {
                character: '\u20BF',
                title: t('gr')
            },
            {
                character: '\u20A5',
                title: t('gs')
            },
            {
                character: '\u20A6',
                title: t('gt')
            },
            {
                character: '\u20A7',
                title: t('gu')
            },
            {
                character: '\u20A8',
                title: t('gv')
            },
            {
                character: '\u20A9',
                title: t('gw')
            },
            {
                character: '\u20AA',
                title: t('gx')
            },
            {
                character: '\u20AB',
                title: t('gy')
            },
            {
                character: '\u20AD',
                title: t('gz')
            },
            {
                character: '\u20AE',
                title: t('ha')
            },
            {
                character: '\u20AF',
                title: t('hb')
            },
            {
                character: '\u20B0',
                title: t('hc')
            },
            {
                character: '\u20B1',
                title: t('hd')
            },
            {
                character: '\u20B2',
                title: t('he')
            },
            {
                character: '\u20B3',
                title: t('hf')
            },
            {
                character: '\u20B4',
                title: t('hg')
            },
            {
                character: '\u20B5',
                title: t('hh')
            },
            {
                character: '\u20B6',
                title: t('hi')
            },
            {
                character: '\u20B7',
                title: t('hj')
            },
            {
                character: '\u20B8',
                title: t('hk')
            },
            {
                character: '\u20B9',
                title: t('hl')
            },
            {
                character: '\u20BA',
                title: t('hm')
            },
            {
                character: '\u20BB',
                title: t('hn')
            },
            {
                character: '\u20BC',
                title: t('ho')
            },
            {
                character: '\u20BD',
                title: t('hp')
            }
        ]);
    }
}